import { getMarketDetail } from './getMarketDetail';
import { getMarketBanner } from './getMarketBanner';
import { getMarketGoodsCarousel } from './getMarketGoodsCarousel';
import { getMarketHomeGoods } from './getMarketHomeGoods';
import { getMarketCouponList } from './getMarketCouponList';
import { postRedeemAllMarketCoupon } from './postRedeemAllMarketCoupon';
import { getMarketParent } from './getMarketParent';
import { getMarketParentHomeGoods } from './getMarketParentHomeGoods';
import { getMarketParentGoodsCarousel } from './getMarketParentGoodsCarousel';
import { getMarketParentCategories } from './getMarketParentCategories';
import { getMarketRankingTypes } from './getMarketRankingTypes';
import { getMarketRankingFilterOptions } from './getMarketRankingFilterOptions';
import { getMarketRankings } from './getMarketRankings';

export const marketService = {
  getMarketDetail: getMarketDetail,
  getMarketBanner: getMarketBanner,
  getMarketCarousel: getMarketGoodsCarousel,
  getMarketHomeGoods,
  getMarketCouponList,
  postRedeemAllMarketCoupon,
  getMarketParent,
  getMarketParentHomeGoods,
  getMarketParentGoodsCarousel,
  getMarketParentCategories,
  getMarketRankingTypes,
  getMarketRankingFilterOptions,
  getMarketRankings,
};
